import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=0a945b0f&"
import script from "./icon.vue?vue&type=script&lang=js&"
export * from "./icon.vue?vue&type=script&lang=js&"
import style0 from "./icon.vue?vue&type=style&index=0&id=0a945b0f&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a945b0f')) {
      api.createRecord('0a945b0f', component.options)
    } else {
      api.reload('0a945b0f', component.options)
    }
    module.hot.accept("./icon.vue?vue&type=template&id=0a945b0f&", function () {
      api.rerender('0a945b0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/superAdmin/menu/icon.vue"
export default component.exports